import moment from 'moment';

export function formatDate(dateStr) {
    const date = moment(dateStr, 'YYYY-MM-DD');
    if (date.isValid()) {
        return date.format('DD/MM/YYYY');
    }
    return '--';
}